// This is a slight overlap with OrganisationLog, but wasnt happy with the implementation there for this purpose
export var OrganisationLifecycleEventType;
(function (OrganisationLifecycleEventType) {
    OrganisationLifecycleEventType["CONNECTED"] = "connected";
    OrganisationLifecycleEventType["DISCONNECTED"] = "disconnected";
    /** When the linked subscription status changes from something else to active */
    OrganisationLifecycleEventType["LINKED_SUBSCRIPTION_ACTIVE"] = "linked_subscription_active";
    /** When the linked subscription status changes to past_due */
    OrganisationLifecycleEventType["LINKED_SUBSCRIPTION_PAST_DUE"] = "linked_subscription_past_due";
    /** when the linked subscription status changes from past due, active to canceled, or is unlinked etc */
    OrganisationLifecycleEventType["LINKED_SUBSCRIPTION_CHURNED"] = "linked_subscription_churned";
    /** A user agreed to the organisation's data being used with AI features */
    OrganisationLifecycleEventType["AI_CONSENT_GIVEN"] = "ai_consent_given";
    /** A Paidnice admin cleared the organisation's AI consent so it is asked again */
    OrganisationLifecycleEventType["AI_CONSENT_REMOVED"] = "ai_consent_removed";
})(OrganisationLifecycleEventType || (OrganisationLifecycleEventType = {}));
//# sourceMappingURL=organisationLifecycleEvent.js.map